import { Injectable } from '@angular/core';
import { gql, Query } from 'apollo-angular';

import { OFFER_BASE_FRAGMENT } from 'graphql/fragments/offer-base';
import { Query as RootQuery } from 'graphql/models/generated';

export const OFFER_SHORT_QUERY = gql`
  query offerShort($documentVersion: DocumentVersionInput!) {
    quotes {
      quote(documentVersion: $documentVersion) {
        ...OfferBaseFragment
      }
    }
  }
  ${OFFER_BASE_FRAGMENT}
`;

@Injectable({
  providedIn: 'root'
})
export class OfferShortQuery extends Query<RootQuery> {
  document = OFFER_SHORT_QUERY;
}
